import {Controller} from "@hotwired/stimulus";
import {getQueryParam} from "../utils/query";

export default class extends Controller {
  connect() {
    const {chapter} = this.element.dataset;

    setTimeout(() => {
        const currentAyah = getQueryParam('ayah', 1)
        const key = `${chapter}:${currentAyah}`;
        const versesToHighlight = document.querySelectorAll(`[data-ayah="${key}"]`);

        if (versesToHighlight.length > 0) {
          versesToHighlight.forEach(el => {
            el.classList.add('highlighted-verse');
          });

          versesToHighlight[0].scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      },
      300
    )
  }
}
